import { WizardStepProperties } from 'components/types'
import { ChangeEvent, FocusEvent, useEffect, useRef, useState } from 'react'
import { FieldChangeEventAnswer } from 'types/general'

import FieldErrorMessage from './FieldErrorMessage'

const Textarea = ({
  name,
  label,
  value,
  errorMessage,
  required,
  isFirstInput,
  onChange,
  setIsValid,
}: WizardStepProperties) => {
  const textareaRef = useRef<HTMLTextAreaElement>(null)
  const [isValidField, setIsValidField] = useState(true)

  const handleChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
    const { name, value } = e.target
    onChange({ name, type: 'textarea', value } as FieldChangeEventAnswer)

    const syntheticEvent = {
      target: e.target,
      relatedTarget: null,
    } as FocusEvent<HTMLTextAreaElement>

    handleBlur(syntheticEvent)
  }

  const handleBlur = (e: FocusEvent<HTMLTextAreaElement>) => {
    const value = e.target.value.trim()

    if (!required && value === '') {
      setIsValidField(true)
      setIsValid?.(true)
    } else if (required && value !== '') {
      setIsValidField(true)
      setIsValid?.(true)
    } else {
      setIsValidField(false)
      setIsValid?.(false)
    }
  }

  useEffect(() => {
    if (isFirstInput && textareaRef.current) {
      textareaRef.current.focus()
    }
  }, [isFirstInput])

  return (
    <div>
      <label
        htmlFor={name}
        className="block text-imovSecondaryDark font-bold mb-2 p-2"
      >
        {label}
      </label>
      <div className="relative">
        <textarea
          ref={textareaRef}
          id={name}
          name={name}
          value={value as string}
          onChange={handleChange}
          onBlur={handleBlur}
          required={required}
          className="w-full my-2 p-2 border-2 border-imovGray rounded-md text-imovSecondary focus:outline-none focus:border-imovPrimaryLight resize-none"
        />
      </div>
      <FieldErrorMessage
        hasError={!isValidField}
        message={errorMessage}
        className="ml-2"
      />
    </div>
  )
}

export default Textarea
